import { render } from "./InitiatorActions.vue?vue&type=template&id=67a8a9c7"
import script from "./InitiatorActions.vue?vue&type=script&lang=js"
export * from "./InitiatorActions.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__